// Please follow snake case for all new event names.

export enum SharedAnalyticsEvents {
  // Full Screen Scorecard
  DownloadScorecardImage = 'download_scorecard_image',
  AiTaskAccepted = 'ai_task_accepted',
  AiTaskRejected = 'ai_task_rejected',

  // Assessment Page
  AssessmentPageView = 'assessment_page_view',
  AiAssessmentRefreshed = 'ai_assessment_refreshed',
}
